import { LazyMapsAPILoaderConfigLiteral } from '@duxor/agm-core';
import { Injectable } from '@angular/core';
import { UserState } from '@store/root-store/auth/auth.reducer';
import { Observable } from 'rxjs';
import { ApiKeyHandler } from '@services/overrides/ApiKeyHandler';

@Injectable()
export class MapsConfig implements LazyMapsAPILoaderConfigLiteral {
  public apiKey: string;
  user$: Observable<UserState>;
  language = 'en';
  libraries = ['drawing', 'places'];

  constructor() {
    this.setApiKey();
  }

  setApiKey() {
    this.apiKey = ApiKeyHandler.getApiKey();
    localStorage.setItem('gak', this.apiKey);
  }
}
